module.exports = __webpack_public_path__ + "static/media/Profile 1.757386ae.svg";